import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  deleteDocumentById,
  getDocumentsForLoad,
  processRpaForLoad,
  restoreDocumentById,
  sendDocumentsToCustomaite,
  uploadDocumentToLoad,
} from '../../../api/v2/load';
import { downloadAllEPOFiles } from '../../../utils/download';

export const useDocumentTable = (id) => {
  return useQuery({ queryKey: ['documentTable', id], queryFn: () => getDocumentsForLoad(id), enabled: !!id });
};

export const useDocumentActions = (id) => {
  const queryClient = useQueryClient();

  const resetDocumentTable = () => {
    //invalidate the documents list so it is re-fetched
    return queryClient.invalidateQueries({
      queryKey: ['documentTable', id],
    });
  };

  const deleteDocument = useMutation({
    mutationFn: ({ fileId }) => deleteDocumentById(fileId),
    onSuccess: () => resetDocumentTable(),
  });

  const restoreDocument = useMutation({
    mutationFn: ({ fileId }) => restoreDocumentById(fileId),
    onSuccess: () => resetDocumentTable(),
  });

  const downloadAllDocuments = useMutation({
    mutationFn: ({ loadId, filename }) => downloadAllEPOFiles(loadId, filename),
  });

  const uploadDocument = useMutation({
    mutationFn: (formData) => uploadDocumentToLoad(formData),
    onSuccess: () => resetDocumentTable(),
  });

  const processRpa = useMutation({
    mutationFn: ({ fileId, filename }) => processRpaForLoad({ fileId, filename }),
  });

  const submitToCustomaite = useMutation({
    mutationFn: (data) => sendDocumentsToCustomaite(data),
  });

  return { deleteDocument, restoreDocument, downloadAllDocuments, uploadDocument, processRpa, submitToCustomaite };
};
